"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabeledTextFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledTextFieldWidget"));
// Component rendered in the user interface
// <div style="display: flex; flex-direction: column">
//   <label for="input-id">
//   <input id="input-id" type="text" [readOnly]>
// </div>
class WCAGTextField extends LabeledTextFieldWidget_1.default {
    constructor(args) {
        super({ ...args });
    }
    decorateLabeledStringFieldWidget(args) {
        this.element = document.createElement("div");
        this.element.classList.add("text-box-field");
        this.add(this.labelElement);
        this.add(this.fieldElement);
        this.add(this.hintElement);
        this.add(this.characterLimitElement);
    }
    parseFieldElementValue(inputValue) {
        return inputValue ?? "";
    }
    setFieldElementValue(value) {
        this.fieldElement.value = value ?? null;
    }
}
exports.default = WCAGTextField;
//# sourceMappingURL=WCAGTextField.js.map